// extracted by mini-css-extract-plugin
export var container = "syntax-diagram-module--container--eSGQz";
export var root = "syntax-diagram-module--root--vJoVV";
export var toolbar = "syntax-diagram-module--toolbar--0ABqv";